/* @ngInject */
const contactRequest = (
  $q,
  contactResource,
  utils,
  valueHandler,
  errorHandler,
  labels
) => {
  const self = {}

  self.getBySearch = async (data) => {
    return $q((resolve, reject) => {
      const functionName = '$owner.getBySearch'
      contactResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            contacts: res.data,
            message: labels.contact.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.contact.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch()
  }

  self.getByOwner = async (_ownerId) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isId(_ownerId)) {
        reject(labels.contact.fields.ownerId.invalid)
      }

      try {
        const response = await self.getBySearch({ ownerId: _ownerId, })
        resolve(response.contacts)
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getById = async (_id) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isId(_id)) {
        reject(labels.contact.fields.id.invalid)
      }

      try {
        const response = await self.getBySearch({ id: _id, })
        const contacts = response.contacts
        if (contacts.length === 1) {
          resolve(contacts[0])
        } else if (contacts.length === 0) {
          reject(labels.contact.log.search.noResultWithId)
        } else {
          reject(labels.contact.fields.id.invalid)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.save = (contact) => {
    return $q((resolve, reject) => {
      const functionName = '$contact.save'

      contactResource.save({}, contact, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.contact.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.contact.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, contact)
            reject(labels.contact.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_contact) => {
    return $q((resolve, reject) => {
      const functionName = '$contact.update'
      contactResource.update({ action: _contact.id }, _contact, (res) => {
        if (res && res.success) {
          const response = {
            contact: res.data,
            message: labels.contact.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _contact)
          reject(labels.contact.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.updateTab = async (_contacts) => {
    const loopPromises = []

    utils.forEach(_contacts, async (contact) => {
      const deferred = $q.defer()
      loopPromises.push(deferred.promise)

      const response = await self.update(contact)
      deferred.resolve(response.message)
    })
    return $q.all(loopPromises)
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$contact.delete'
      contactResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.contact.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.contact.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default contactRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/request.service.js